import '../../styles/Footer.css';
import {
  RiFacebookCircleFill,
  RiInstagramFill,
  RiTwitterFill,
  RiYoutubeFill,
  RiPhoneFill,
  RiMailFill,
  RiMapPinFill,
  RiTruckFill,
  RiRefreshFill,
  RiShieldCheckFill,
  RiCustomerService2Fill
} from 'react-icons/ri';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="footer-container">
          
          {/* Shop Categories */}
          <div className="footer-section">
            <h4 className="footer-title">Shop by Room</h4>
            <ul className="footer-links">
              <li><a href="#">Living Room</a></li>
              <li><a href="#">Bedroom</a></li>
              <li><a href="#">Kitchen & Dining</a></li>
              <li><a href="#">Bathroom</a></li>
              <li><a href="#">Home Office</a></li>
              <li><a href="#">Kids Room</a></li>
              <li><a href="#">Outdoor</a></li>
            </ul>
          </div>

          {/* Products */}
          <div className="footer-section">
            <h4 className="footer-title">Products</h4>
            <ul className="footer-links">
              <li><a href="#">Furniture</a></li>
              <li><a href="#">Storage & Organization</a></li>
              <li><a href="#">Décor & Textiles</a></li>
              <li><a href="#">Lighting</a></li>
              <li><a href="#">Kitchen & Appliances</a></li>
              <li><a href="#">Mattresses</a></li>
              <li><a href="#">Smart Home</a></li>
            </ul>
          </div>

          {/* Services */}
          <div className="footer-section">
            <h4 className="footer-title">Services</h4>
            <ul className="footer-links">
              <li><a href="#">Delivery Service</a></li>
              <li><a href="#">Assembly Service</a></li>
              <li><a href="#">Interior Design</a></li>
              <li><a href="#">Kitchen Planning</a></li>
              <li><a href="#">Product Measurements</a></li>
              <li><a href="#">Click & Collect</a></li>
              <li><a href="#">Spare Parts</a></li>
            </ul>
          </div>

          {/* Help & Support */}
          <div className="footer-section">
            <h4 className="footer-title">Help & Support</h4>
            <ul className="footer-links">
              <li><a href="#">Customer Service</a></li>
              <li><a href="#">FAQ</a></li>
              <li><a href="#">Size Guide</a></li>
              <li><a href="#">Care Instructions</a></li>
              <li><a href="#">Returns & Exchanges</a></li>
              <li><a href="#">Track Your Order</a></li>
              <li><a href="#">Warranty</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h4 className="footer-title">Contact Us</h4>
            <div className="footer-contact">
              <div className="contact-item">
                <RiPhoneFill className="contact-icon" />
                <span>+597 546-450</span>
              </div>
              <div className="contact-item">
                <RiMailFill className="contact-icon" />
                <span>info@buildingdepotsr.com</span>
              </div>
              <div className="contact-item">
                <RiMapPinFill className="contact-icon" />
                <span>Paramaribo, Suriname</span>
              </div>
            </div>
            
            <div className="footer-social">
              <h5>Follow Us</h5>
              <div className="social-links">
                <a href="https://www.facebook.com/buildingdepotsr/" target='_blank' aria-label="Facebook"><RiFacebookCircleFill /></a>
                <a href="https://www.instagram.com/buildingdepotsuriname/?hl=en" target='_blank' aria-label="Instagram"><RiInstagramFill /></a>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* Features Bar */}
      <div className="footer-features">
        <div className="footer-container">
          <div className="features-grid">
            <div className="feature-item">
              <RiTruckFill className="feature-icon" />
              <div className="feature-text">
                <strong>Free Delivery</strong>
                <span>On orders over $200</span>
              </div>
            </div>
            <div className="feature-item">
              <RiRefreshFill className="feature-icon" />
              <div className="feature-text">
                <strong>365-Day Returns</strong>
                <span>Easy returns & exchanges</span>
              </div>
            </div>
            <div className="feature-item">
              <RiShieldCheckFill className="feature-icon" />
              <div className="feature-text">
                <strong>Quality Guarantee</strong>
                <span>25-year limited warranty</span>
              </div>
            </div>
            <div className="feature-item">
              <RiCustomerService2Fill className="feature-icon" />
              <div className="feature-text">
                <strong>Expert Support</strong>
                <span>Design consultation</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <div className="footer-container">
          <div className="footer-bottom-content">
            <div className="footer-logo">
              <span>Building Depot Suriname: Lights & Living</span>
            </div>
            <div className="footer-legal">
              <span>© 2025 Building Depot Suriname. All rights reserved.</span>
              <div className="legal-links">
                <a href="#">Privacy Policy</a>
                <a href="#">Terms & Conditions</a>
                <a href="#">Cookie Policy</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
